import React, { useEffect, useRef } from 'react';
import { VideoNativeProps } from '../../../types/components';

interface VideoProps {
  children: any;
  muted: boolean;
  nativeProps?: VideoNativeProps;
}

const Video = (props: VideoProps) => {
  const { children, nativeProps, muted } = props;
  const videoRef: any = useRef(null);

  useEffect(() => {
    if (muted) {
      videoRef.current.muted = true;
      videoRef.current.setAttribute('muted', '');
    }
    videoRef.current.play();
  }, [muted]);

  return (
    <video
      ref={videoRef}
      preload="metadata"
      playsInline={true}
      loop={true}
      {...nativeProps}
    >
      {children}
    </video>
  );
};

export default Video;
